import AddClientPage from "@/app/shared/clients/add-client-modal";
import ClientPageHeader from "./page-header";
import { CreateClient } from "@/server/api-services";
import { RegisterClient } from "@/types";
import toast from "react-hot-toast";

export default function CreateClientPage() {
    const pageHeader = {
        title: "User Management",
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                name: "Clients",
            },
        ],
    };

    async function handleSave(client: RegisterClient) {
        const response = await CreateClient(client);

        if (response.statusCode !== 200) {
            toast.error("Failed to add client");
            return;
        }
    }

    return (
        <>
            <ClientPageHeader title={pageHeader.title}></ClientPageHeader>
            <AddClientPage />
        </>
    );
}
